<template>
  <div
    :id="id"
    style="position: absolute;width: 100%;height: 100vh;left: 0px;top: 0px;overflow: hidden;"
  ></div>
</template>
<script>
export default {
  data() {
    return {
      id:"vr",
      tbConfig:{
        videoQuality: 1,
        videoList:[]
      },
      videoList: [],
      isShowAll: true,
      params: {
        container: null,
        name: "SceneViewer",
        isGyro: true, //默认开启陀螺仪功能  移动端支持陀螺仪设备有效
        isMouseWheel: false, //禁止滚轮缩放
        scenesArr: [],
        initOverCallBack: function() {
          this.isShowAll = false;
        },
        errorCallBack: function(e) {
          console.log("错误状态：" + e);
        },
        sceneEventClickCallBack: function(e) {
          if (this.isShowAll) {
            this.isShowAll = false;
          } else {
            this.isShowAll = true;
          }
        },
        fsCallBack: function(status, playObj) {
          alert("浏览器不支持全屏！");
        }
      }
    };
  },
  props: {
    result: {
      type: Object
    },
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
   
  },
  components: {
  },
  watch:{
    result: function(to, from) {
      this.id = "vr" + Math.ceil(Math.random() * 100000000);
      this.params.container=document.getElementById(this.id);
      this.params.scenesArr=[
          {
            sceneId: "v1",
            sceneName: "赛车",
            sceneFilePath: this.result.data.videoUrl,
            sceneType: "Video"
          }
        ]
        this.videoList.push({
            Text: "超高清",
            Quality: 1,
            Resolution: "2048x1024",
            M3U8: this.result.data.videoUrl,
            RTMP: null
        });
        initLoad(this.params, function(playMode) {}, this.tbConfig);
    }
  }
};
</script>

